import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LoginStoreEffects } from './effects';
import { loginReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature('User', loginReducer), EffectsModule.forFeature([LoginStoreEffects])],
  providers: [LoginStoreEffects]
})
export class LoginStoreModule {
  User: any;
}
